import {
    Button,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import baseURL from "../../configs/api";
import { EditorState, convertToRaw } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import draftToHtml from "draftjs-to-html";
import axois from "../../configs/axois";
import useAuth from "../../components/hooks/useAuth";
import Cookies from "js-cookie";
import { useTheme } from "../../components/hooks/useTheme";
import PleaseWaitPopup from "../PleaseWaitPopup";
import colorConfigs from "../../configs/colorConfigs";
import useTenant from "../../components/hooks/useTenant";

export const AddDailyNotes = () => {
    const tenantId = Cookies.get("tenantId-jj-rental-ui") || "";
    const { themeStyles } = useTheme();
    const { auth }: any = useAuth();
    const { handleTenantError }: any = useTenant();
    const [notes, setNotes] = useState<string>("");
    const [currentLocations, setCurrentLocations] = useState<any[]>([]);
    const [currentLocationId, setCurrentLocationId] = useState<string>("");
    const [pleaseWaitPopup, setPleaseWaitPopup] = useState<boolean>(false);

    const [editorState, setEditorState] = useState(() =>
        EditorState.createEmpty()
    );

    useEffect(() => {
        setNotes(draftToHtml(convertToRaw(editorState.getCurrentContent())));

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [editorState]);

    useEffect(() => {
        axois
            .get(`${baseURL}location`, {
                headers: {
                    'X-Tenant-ID': tenantId,
                     "Content-Type": "application/json" 
                },
            })
            .then((response) => {
                setCurrentLocations(() =>
                    response.data.map((item: any) => {
                        return { value: item.id, label: item.locationName };
                    })
                );

                setCurrentLocationId(response.data[0]?.id);
                handleTenantError(null);
            })
            .catch((error) => {
                handleTenantError(error);
            });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const navigate = useNavigate();
    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        setPleaseWaitPopup(true);
        await axios
            .post(
                `${baseURL}dailyNote?userId=${auth?.id}`,
                JSON.stringify({                  
                    locationId: currentLocationId,
                    note: notes,
                    createdBy: auth?.givenname,
                    createdAt: new Date().toLocaleString(),
                    updateBy: auth?.givenname,
                    updateAt: new Date().toLocaleString(),
                }),
                {
                    headers: {
                        'X-Tenant-ID': tenantId,
                         "Content-Type": "application/json" 
                    },
                    withCredentials: true,
                }
            )
            .then((_) => {
                setPleaseWaitPopup(false);
                navigate(-1);
                handleTenantError(null);
            })
            .catch((error) => {
                setPleaseWaitPopup(false);
                handleTenantError(error);
            });
    }


    return (
        <>
            <div className={`px-[24px] py-[20px] min-h-screen h-full ${themeStyles.main.tailwindSectionBg}`}>
                <div className={`w-full ${themeStyles.main.tailwindMainBg} rounded-lg p-[10px] pb-[40px] flex flex-col gap-2.51`}>
                    <div className="w-full mt-2">
                        <div className={`w-full pb-4`}>

                            <div className={`flex justify-between items-center p-2 border-b ${themeStyles.main.borderColor}`}>
                                <div className="flex items-center gap-1.5">
                                    <h2 className={`text-lg font-semibold ${themeStyles.main.textHeadingColor}`}>Add Daily Notes</h2>
                                </div>
                            </div>

                            <div className="mt-2 p-2 w-full">
                                <form onSubmit={(e) => handleSubmit(e)}>
                                    <div className="w-full px-2">
                                        <div className="w-full">

                                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Notes</label>
                                            <Editor
                                                editorStyle={{
                                                    border: `1px solid #D0D0D0`,
                                                    backgroundColor: "white",
                                                    minHeight: "250px",
                                                    maxHeight: "250px",
                                                    overflowY: "auto",
                                                    overflowX: "hidden",
                                                    padding: "10px",
                                                    width: "100%",
                                                    wordWrap: "break-word",
                                                    whiteSpace: "pre-wrap"
                                                }}
                                                editorState={editorState}
                                                wrapperClassName="wrapper-class"
                                                editorClassName="editor-class"
                                                toolbarClassName="toolbar-class"
                                                onEditorStateChange={setEditorState}
                                                toolbar={{
                                                    inline: { inDropdown: true },
                                                    list: { inDropdown: true },
                                                    textAlign: { inDropdown: true },
                                                    link: { inDropdown: true },
                                                    history: { inDropdown: true },
                                                }}
                                                wrapperStyle={{
                                                    width: "100%",
                                                    maxWidth: "1200px",
                                                    border: "1px solid #ccc",
                                                    display: "flex",
                                                    flexDirection: "column",
                                                }}
                                                toolbarStyle={{
                                                    borderBottom: "1px solid #ccc",
                                                    paddingBottom: "5px",
                                                }}
                                            />
                                        </div>

                                        <div className="w-[40%]">

                                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Location</label>
                                            <select
                                                className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                                value={currentLocationId}
                                                onChange={(e) => setCurrentLocationId(e.target.value)}
                                            >
                                                <option className={`${themeStyles.main.tailwindSectionBg}`} value={0}>None</option>
                                                {
                                                    currentLocations.map((item: any, index: number) => {
                                                        return <option key={index} className={`${themeStyles.main.tailwindSectionBg}`} value={item.value}>{item.label}</option>
                                                    })
                                                }

                                            </select>
                                        </div>

                                        <div className="flex gap-4 mt-6">
                                            <Button variant="contained"
                                                sx={{
                                                    backgroundColor: colorConfigs.btn.main.bg
                                                }}
                                                type="submit"
                                            >
                                                Save
                                            </Button>

                                            <Button variant="contained"
                                                sx={{
                                                    backgroundColor: colorConfigs.btn.cancel.bg,
                                                    border: colorConfigs.btn.cancel.border,
                                                    color: colorConfigs.btn.cancel.color
                                                }}
                                                onClick={() => navigate(-1)}
                                            >
                                                Cancel
                                            </Button>
                                        </div>
                                    </div>
                                </form>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <PleaseWaitPopup pleaseWaitPopup={pleaseWaitPopup} />
        </>
    );
};